// MIRRORED FILE — keep in sync with functions/utils/quantityParser.js.
// CRA can't import outside src/ and Functions can't import from client/src,
// so this module is duplicated. The only permitted difference between the
// two files is the export syntax (ESM here, CommonJS in /functions).

// A number + recognized unit ("5 bags of flour", "2cups sugar"). The unit is
// REQUIRED here and must be followed by whitespace or end-of-string — otherwise
// a leading letter would be mistaken for a unit ("3 lemons" → the "l" of lemons).
const UNIT_PATTERN =
  /^(\d+(?:\.\d+)?)\s*(bags?|bottles?|pounds?|lbs?|gallons?|cans?|boxes?|packs?|pieces?|cups?|ounces?|oz|liters?|l)(?=\s|$)\s*(of\s+)?(.+)/i;

// A bare number followed by whitespace ("20 bookcase"). The whitespace is
// required so dimensions/model numbers glued to the digits ("20x12 bookcase",
// "2x4 lumber") are NOT split into a quantity.
const SIMPLE_PATTERN = /^(\d+(?:\.\d+)?)\s+(.+)/;

export function extractQuantity(content) {
  const unitMatch = content.match(UNIT_PATTERN);
  if (unitMatch) {
    const qtyNumber = parseFloat(unitMatch[1]);
    const unit = unitMatch[2] || '';
    const baseItem = unitMatch[4].trim();
    const qtyString = unit ? `${qtyNumber}${unit}` : qtyNumber.toString();
    return { hasQuantity: true, quantity: qtyString, unit, baseItem };
  }

  const simpleMatch = content.match(SIMPLE_PATTERN);
  if (simpleMatch) {
    const qtyNumber = parseFloat(simpleMatch[1]);
    const baseItem = simpleMatch[2].trim();
    return { hasQuantity: true, quantity: qtyNumber.toString(), unit: '', baseItem };
  }

  return { hasQuantity: false, quantity: null, unit: null, baseItem: content };
}
